export const isStaging = () =>
  import.meta.env.VITE_API_URL?.includes("staging");

export const isDev = () => import.meta.env.VITE_API_URL?.includes("localhost");
